import React from 'react';
import { SEOHead } from '../components/SEOHead';
import { Link } from 'react-router-dom';
import { Badge } from '../components/ui/badge';
import { COMPANY_INFO } from '../lib/utils';

export default function MentionsLegalesPage() {
  return (
    <div>
      <SEOHead title="Mentions légales" description="Mentions légales de Ptitservices.com, entreprise de services à la personne dans l'Artois (déclaration SAP, éditeur, hébergeur)." path="/mentions-legales" />
      <section className="bg-[linear-gradient(135deg,hsla(195,20%,97%,1)_0%,hsla(182,40%,94%,1)_55%,hsla(195,20%,97%,1)_100%)] py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="flex items-center gap-2 text-sm text-muted-foreground mb-6">
            <Link to="/" className="hover:text-foreground">Accueil</Link>
            <span>/</span>
            <span className="text-foreground font-medium">Mentions légales</span>
          </div>
          <Badge className="mb-3 bg-[hsl(var(--brand-mint))] text-[hsl(var(--brand-ink))] hover:bg-[hsl(var(--brand-mint))]">Légal</Badge>
          <h1 className="font-['Space_Grotesk'] text-3xl sm:text-4xl font-semibold tracking-tight">Mentions légales</h1>
        </div>
      </section>

      <section className="py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 prose prose-sm max-w-none">
          <div className="space-y-8">
            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">Éditeur du site</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-1">
                <p><strong>Raison sociale :</strong> Ptitservices.com</p>
                <p><strong>Forme juridique :</strong> Société de services à la personne</p>
                <p><strong>Siège social :</strong> {COMPANY_INFO.address}, {COMPANY_INFO.city}</p>
                <p><strong>Téléphone :</strong> {COMPANY_INFO.phone}</p>
                <p><strong>Email :</strong> {COMPANY_INFO.email}</p>
                <p><strong>Directeur de la publication :</strong> Le représentant légal de Ptitservices.com</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">Hébergement</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-1">
                <p>Le site ptitservices.com est hébergé par un prestataire professionnel d'hébergement web.</p>
                <p>Les coordonnées de l'hébergeur sont disponibles sur demande auprès de l'éditeur du site.</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">Activité</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-1">
                <p>Ptitservices.com est un organisme de services à la personne agréé, spécialisé dans les prestations de services à domicile : entretien ménager, jardinage, repassage, petit bricolage, aide aux courses, aide aux repas et assistance administrative.</p>
                <p>Tous nos services sont éligibles au crédit d'impôt de 50% conformément aux articles 199 sexdecies et suivants du Code Général des Impôts.</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">Propriété intellectuelle</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-1">
                <p>L'ensemble du contenu de ce site (textes, images, vidéos, logos, graphismes, icônes) est la propriété exclusive de Ptitservices.com, sauf mention contraire.</p>
                <p>Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle, de ces différents éléments est strictement interdite sans l'accord expresse par écrit de Ptitservices.com.</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">Responsabilité</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-1">
                <p>Ptitservices.com s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Cependant, Ptitservices.com ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.</p>
                <p>Ptitservices.com décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.</p>
                <p>Les tarifs indiqués sur le site sont donnés à titre indicatif et peuvent varier en fonction des prestations demandées. Seul le devis établi par Ptitservices.com fait foi.</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">Liens hypertextes</h2>
              <div className="text-sm text-muted-foreground leading-relaxed">
                <p>Le site ptitservices.com peut contenir des liens hypertextes vers d'autres sites internet. Ptitservices.com ne saurait être tenu responsable du contenu de ces sites externes.</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">Droit applicable</h2>
              <div className="text-sm text-muted-foreground leading-relaxed">
                <p>Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.</p>
              </div>
            </div>

            <div className="pt-4 border-t border-border">
              <p className="text-xs text-muted-foreground">Dernière mise à jour : Janvier 2025</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
